import React from 'react'

const BASE_CLASS = "w-full max-w-3xl h-64 mx-auto my-4 bg-white rounded-xl shadow-md overflow-hidden";

export default function ServiceCards({ titre, texte, image, animation = 'aos', delay = 0}) {
  const cssAnimation = animation === 'css';

  const animationProps = cssAnimation
    ? { style: { animationDelay: `${delay}ms` } }
    : { 'data-aos': 'fade-up', 'data-aos-duration': '1500' };

  return (
    <div className={cssAnimation ? `${BASE_CLASS} card-anim` : BASE_CLASS} {...animationProps}>
      <div className="flex flex-col sm:flex-row h-full">
        <div className="w-full h-32 sm:h-full sm:w-48 shrink-0">
            <img src={image} className="h-full w-full object-contain" alt=""/>
        </div>
        <div className="p-6 flex flex-col justify-center overflow-hidden">
          <h2 className="text-xl font-bold text-gray-900 mb-2 truncate">{titre}</h2>
          <p className="text-gray-600 text-sm leading-relaxed line-clamp-4">{texte}</p>
        </div>
      </div>
    </div>
  );
}
